import Vue from 'vue'
import RateLimiter from "@/utils/ratelimiter"

const limiter = new RateLimiter(1)
export default Vue.observable(limiter)